(function () {
  'use strict';
  var unit = 'usd-cent-v1';
  var dollars = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'});
  var numbers = new Intl.NumberFormat('en-US');
  function money(cents) { return dollars.format(cents / 100); }
  function label(cents) { return money(cents) + ' · ' + numbers.format(cents) + (cents === 1 ? ' credit' : ' credits'); }
  function paint(data) {
    if (!data || data.creditUnit !== unit || !Number.isSafeInteger(data.available) || data.available < 0) throw new Error('Refresh the page to load your credit balance.');
    document.querySelectorAll('[data-token-balance]').forEach(function (node) { node.textContent = money(data.available); });
    document.querySelectorAll('[data-credit-count]').forEach(function (node) { node.textContent = numbers.format(data.available) + ' credits · 100 credits = $1 USD'; });
    document.querySelectorAll('[data-wallet-breakdown]').forEach(function (node) { node.textContent = money(data.purchasedAvailable) + ' purchased · ' + money(data.monthlyAvailable) + ' monthly'; });
  }
  window.UNREEL_CREDITS = {unit: unit, money: money, label: label, paint: paint};
})();
